const accessRoute = {
  AI_MATCHING_SCORE: {
    path: "/ai-matching-score",
  },
};
export default accessRoute;
